"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from "@tanstack/react-query";
import EventSource from "eventsource";
import { useEffect, useState } from "react";
import { NotificationStreamContext } from "./NotificationStreamContext";
const MAX_RECONNECT_RETRIES = 3;
export const NotificationStreamContextProvider = ({ streamURL, children, }) => {
    var _a, _b;
    const [eventSource, setEventSource] = useState(null);
    const queryClient = useQueryClient();
    const { authToken } = (_b = (_a = queryClient.getDefaultOptions().queries) === null || _a === void 0 ? void 0 : _a.meta) !== null && _b !== void 0 ? _b : {};
    useEffect(() => {
        if (streamURL == null) {
            // eslint-disable-next-line no-console
            console.warn("streamURL was not provided to the useNotificationStream hook");
            return;
        }
        if (authToken == null) {
            throw new Error("authToken in meta required");
        }
        let reconnectRetries = 0;
        const newEventSource = new EventSource(streamURL, {
            headers: { Authorization: authToken },
        });
        newEventSource.addEventListener("error", () => {
            reconnectRetries += 1;
            if (reconnectRetries >= MAX_RECONNECT_RETRIES) {
                newEventSource.close();
            }
        });
        newEventSource.addEventListener("open", () => {
            reconnectRetries = 0;
        });
        setEventSource(newEventSource);
        // eslint-disable-next-line consistent-return
        return () => {
            setEventSource((existingEventSource) => {
                if (existingEventSource != null) {
                    existingEventSource.close();
                }
                return null;
            });
        };
    }, [authToken, queryClient, streamURL]);
    return (_jsx(NotificationStreamContext.Provider, { value: eventSource, children: children }));
};
//# sourceMappingURL=NotificationStreamContextProvider.js.map